import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=146d2ac3&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=146d2ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d2ac3",
  null
  
)

export default component.exports